import React from 'react';
import { Routes as RouterRoutes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '../components/Home';
import Privacy from '../components/Privacy';
import Terms from '../components/Terms';
import HowToGuide from '../components/HowToGuide';
import Signup from '../components/Signup';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import Upgrade from '../components/Upgrade';
import SignupSuccess from '../components/SignupSuccess';
import UpgradeSuccess from '../components/UpgradeSuccess';
import Problem from '../components/Problem';
import ConfirmedEmail from '../components/ConfirmedEmail';
import Timezone from '../components/Timezone';
import TimezoneSuccess from '../components/TimezoneSuccess';
import Welcome from '../components/Welcome';

// Public Route Component (only accessible if NOT logged in)
const PublicRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (token) {
        // Redirect to Today if already logged in
        return <Navigate to="/" replace />;
    }
    return children;
};

const Routes = () => {
    const location = useLocation();
    
    React.useEffect(() => {
        // Remove all page-specific classes
        document.documentElement.classList.remove('backgroundColorWhite', 'backgroundLightGreyColor');
        
        // Add the appropriate class based on the current path
        switch(location.pathname) { 
            case '/':           
                document.documentElement.classList.add('backgroundColorWhite');
                break;
            default:
                document.documentElement.classList.add('backgroundColorWhite');
                break;
        }
    }, [location]);

    return (
        <RouterRoutes>
            {/* Public Routes */}
            <Route path="/" element={
                <PublicRoute>
                    <Home />
                </PublicRoute>
            } />

            <Route path="/privacy" element= {
                <PublicRoute>
                    <Privacy />
                </PublicRoute>
            } />

            <Route path="/terms" element= {
                <PublicRoute>
                    <Terms />
                </PublicRoute>
            } />

            <Route path="/sign-up" element= {
                <PublicRoute>
                    <Signup />
                </PublicRoute>
            } />

            <Route path="/sign-up-success" element= {
                <PublicRoute>
                    <SignupSuccess />
                </PublicRoute>
            } />

            <Route path="/upgrade" element= {
                <PublicRoute>
                    <Upgrade />
                </PublicRoute>
            } />

            <Route path="/upgrade-success" element= {
                <PublicRoute>
                    <UpgradeSuccess />
                </PublicRoute>
            } />
            
            
            <Route path="/update-timezone/:id" element= {
                <PublicRoute>
                    <Timezone />
                </PublicRoute>
            } />

            <Route path="/timezone-success" element= {
                <PublicRoute>
                    <TimezoneSuccess />
                </PublicRoute>
            } />

            <Route path="/pricing" element= {
                <PublicRoute>
                    <Pricing />
                </PublicRoute>
            } />

            <Route path="/features" element= {
                <PublicRoute>
                    <Features />
                </PublicRoute>
            } />

            <Route path="/how-to" element= {
                <PublicRoute>
                    <HowToGuide />
                </PublicRoute>
            } />

            <Route path="/contact" element= {
                <PublicRoute>
                    <Contact />
                </PublicRoute>
            } />

            <Route path="/confirmed" element= {
                <PublicRoute>
                    <ConfirmedEmail />
                </PublicRoute>
            } />

            <Route path="/problem" element= {
                <PublicRoute>
                    <Problem />
                </PublicRoute>
            } />

            <Route path="/welcome" element= {
                <PublicRoute>
                    <Welcome />
                </PublicRoute>
            } />

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/?utm_source=404" replace />} />
        </RouterRoutes>
    );
};

export default Routes;
